<template>
  <h2 class="pb-2 border-bottom">Telemedicine</h2>
  <p>Telemedicine: accessible care wherever you are</p>
  <p>At Diverse Care Now, you can receive medical care from home  in English, Portuguese, or Spanish. Our telemedicine services cover general health, chronic conditions, weight management, hormone therapy, and mental health support.”</p>
  <ul>
    <li>General Primary Care — online consultations for common illnesses (cold, flu, allergies), prescription refills, chronic disease follow-ups (diabetes, hypertension, thyroid), and preventive health guidance.</li>
    <li>Weight Management & Metabolic Health — virtual monitoring and safe prescriptions (including physician-supervised therapies), nutrition counseling, and medically supervised programs to support healthy weight.</li>
    <li>Men’s & Women’s Health — telemedicine support for HRT and TRT follow-ups, menopause, PCOS, and ongoing hormonal balance.</li>
    <li>Mental Health & Lifestyle Support — online counseling for anxiety and depression management, lifestyle and wellness coaching.</li>
  </ul>
  <p>“With our secure telemedicine platform, you receive the same personalized care as in our clinic — but from the comfort of your home.”</p>
</template>

<script>
export default {
  name: 'TelemedicineContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
